"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorHttp = void 0;
const core_1 = require("@comunica/core");
const readable_web_to_node_stream_1 = require("readable-web-to-node-stream");
// TODO: Remove when targeting NodeJS 18+
global.ReadableStream = global.ReadableStream || require('web-streams-ponyfill').ReadableStream;
const isStream = require('is-stream');
const toWebReadableStream = require('readable-stream-node-to-web');
/**
 * A base actor for listening to HTTP events.
 *
 * Actor types:
 * * Input:  IActionHttp:      The HTTP request.
 * * Test:   IActorHttpTest:   An estimate for the response time.
 * * Output: IActorHttpOutput: The HTTP response.
 *
 * @see IActionHttp
 * @see IActorHttpTest
 * @see IActorHttpOutput
 */
class ActorHttp extends core_1.Actor {
    /**
     * @param args - @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     */
    constructor(args) {
        super(args);
    }
    /**
     * Converts WhatWG streams to Node streams if required.
     * Returns the input in case the stream already is a Node stream.
     * @param {ReadableStream} body
     * @returns {NodeJS.ReadableStream}
     */
    static toNodeReadable(body) {
        return isStream(body) || body === null ?
            body :
            new readable_web_to_node_stream_1.ReadableWebToNodeStream(body);
    }
    /**
     * Converts Node streams to WhatWG streams.
     * @param {NodeJS.ReadableStream} body
     * @returns {ReadableStream}
     */
    static toWebReadableStream(body) {
        return toWebReadableStream(body);
    }
    /**
     * Convert the given headers object into a raw hash.
     * @param headers A headers object.
     */
    static headersToHash(headers) {
        const hash = {};
        headers.forEach((value, key) => {
            hash[key] = value;
        });
        return hash;
    }
}
exports.ActorHttp = ActorHttp;
//# sourceMappingURL=ActorHttp.js.map